import type { IEntityAppointment } from '@user/store/scheduling'

import { useGetOrderUrl } from '../../../hooks'
import { useMemo } from 'react'
import { getFormattedAddress } from '@sales-center/common'

export function useGetCardData(input: IEntityAppointment) {
  const { appointmentId, appointmentType } = input

  const orderUrl = useGetOrderUrl(appointmentId)

  const allowActions = appointmentType === 'Estimate'

  const formattedAddress = useMemo(
    () =>
      getFormattedAddress(
        input.serviceLocationAddress?.lineOne ?? '',
        input.serviceLocationAddress?.lineTwo ?? '',
        input.serviceLocationAddress?.city ?? '',
        input.serviceLocationAddress?.state ?? '',
        input.serviceLocationAddress?.postalCode ?? '',
      ),
    [
      input.serviceLocationAddress?.city,
      input.serviceLocationAddress?.lineOne,
      input.serviceLocationAddress?.lineTwo,
      input.serviceLocationAddress?.postalCode,
      input.serviceLocationAddress?.state,
    ],
  )

  return {
    orderUrl,
    allowActions,
    formattedAddress,
  }
}
